import { useCallback, useEffect, useState } from 'react';

type InViewProps = {
  delayed?: boolean;
};
const useInView = <T extends HTMLElement>({ delayed }: InViewProps) => {
  const [inView, setInView] = useState<boolean>(false);
  const [element, setElement] = useState<T>();
  const ref = useCallback(
    (element: T) => {
      if (element) {
        setElement(element);
      }
    },
    [setElement]
  );

  useEffect(() => {
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }
    );
    const observe = () => observer.observe(element);
    let timeoutId: number;

    if (delayed) {
      timeoutId = window.setTimeout(observe, 1000);
    } else {
      observe();
    }

    return () => {
      observer.disconnect();
      clearTimeout(timeoutId);
    };
  }, [element, delayed]);

  return { ref, inView };
};

export default useInView;
